import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-detail-operation-data',
  templateUrl: './detail-operation-data.component.html',
  styleUrls: ['./detail-operation-data.component.css']
})
export class DetailOperationDataComponent implements OnInit {
  @Input() transactionData;
  constructor() { }

  ngOnInit() {
  }

}
